import { hoverTypes } from 'layout-dnd-utils/constants/dndAreaHoverPositionConstants';
import { ROW_DRAG_HANDLE, COLUMN_DRAG_HANDLE, MODULE_DRAG_HANDLE, EMPTY_CONTAINER_DRAG_HANDLE, TOPMOST_SECTION_ROW_DRAG_HANDLE, INSERT_NEW_SECTION_HANDLE, VERTICAL_STACK_DRAG_HANDLE, HORIZONTAL_STACK_DRAG_HANDLE, TABLE_DRAG_HANDLE } from 'InpageEditorUI/lib/layoutSection/constants';
import { layoutNodeTypes } from 'layout-dnd-utils/constants/dndAreaHoverPositionConstants';
export function calculateGridDragHandlesFromHoverPositions(hoverPositions) {
  if (hoverPositions.length === 0 || hoverPositions[0].type === hoverTypes.OUTSIDE_LAYOUT_SECTION) {
    return null;
  }

  // TODO: Figure out why this is here
  // if (hoverPositions[0].type !== hoverTypes.INNER_TRIANGLE) {
  //   hoverPositions = hoverPositions.slice(1);
  // }

  let nextHoverPosition;
  // let foundModule = false;

  const handlesToGather = [];
  for (let i = 0; i < hoverPositions.length; i++) {
    const currHoverPosition = hoverPositions[i];
    nextHoverPosition = hoverPositions[i + 1];

    // if (
    //   nextHoverPosition?.layoutNodeType === 'grid_layout_horizontal_stack' &&
    //   currHoverPosition.nextSiblingId
    // ) {
    //   handlesToGather.push({
    //     gridLayoutId: currHoverPosition.gridLayoutId,
    //     type: RESIZE_HANDLE_RIGHT,
    //     depth: currHoverPosition.depth,
    //     id: currHoverPosition.id,
    //     nextSiblingId: currHoverPosition.nextSiblingId,
    //     parentId: nextHoverPosition?.id,
    //   });
    // } else if (
    //   nextHoverPosition?.layoutNodeType === 'grid_layout_horizontal_stack' &&
    //   currHoverPosition.previousSiblingId
    // ) {
    //   handlesToGather.push({
    //     gridLayoutId: currHoverPosition.gridLayoutId,
    //     type: RESIZE_HANDLE_LEFT,
    //     depth: currHoverPosition.depth,
    //     id: currHoverPosition.id,
    //     previousSiblingId: currHoverPosition.previousSiblingId,
    //     parentId: nextHoverPosition?.id,
    //   });
    // }

    if (currHoverPosition.layoutNodeType === layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK) {
      var _nextHoverPosition;
      // if (
      //   currHoverPosition.type === hoverTypes.INNER_TRIANGLE &&
      //   currHoverPosition.numChildren === 0
      // ) {
      //   // TODO: Figure out what this is doing
      //   handlesToGather.push({
      //     gridLayoutId: currHoverPosition.gridLayoutId,
      //     type: EMPTY_CONTAINER_DRAG_HANDLE,
      //     depth: currHoverPosition.depth,
      //     id: currHoverPosition.id,
      //     parentId: nextHoverPosition?.id,
      //   });
      // } else {
      handlesToGather.push({
        gridLayoutId: currHoverPosition.gridLayoutId,
        type: VERTICAL_STACK_DRAG_HANDLE,
        depth: currHoverPosition.depth,
        id: currHoverPosition.id,
        layoutNodeType: currHoverPosition.layoutNodeType,
        isGridCell: currHoverPosition.isGridCell,
        parentId: (_nextHoverPosition = nextHoverPosition) === null || _nextHoverPosition === void 0 ? void 0 : _nextHoverPosition.id
      });
      // }
    } else if (currHoverPosition.layoutNodeType === layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK) {
      var _nextHoverPosition2;
      // if (
      //   currHoverPosition.type === hoverTypes.INNER_TRIANGLE &&
      //   currHoverPosition.numChildren === 0
      // ) {
      //   // TODO: Figure out what this is doing
      //   handlesToGather.push({
      //     gridLayoutId: currHoverPosition.gridLayoutId,
      //     type: EMPTY_CONTAINER_DRAG_HANDLE,
      //     depth: currHoverPosition.depth,
      //     id: currHoverPosition.id,
      //     parentId: nextHoverPosition?.id,
      //   });
      // }
      // else {
      handlesToGather.push({
        type: HORIZONTAL_STACK_DRAG_HANDLE,
        gridLayoutId: currHoverPosition.gridLayoutId,
        depth: currHoverPosition.depth,
        id: currHoverPosition.id,
        layoutNodeType: currHoverPosition.layoutNodeType,
        isGridCell: currHoverPosition.isGridCell,
        parentId: (_nextHoverPosition2 = nextHoverPosition) === null || _nextHoverPosition2 === void 0 ? void 0 : _nextHoverPosition2.id
      });
      // }
    } else if (currHoverPosition.layoutNodeType === layoutNodeTypes.GRID_LAYOUT_GRID) {
      var _nextHoverPosition3;
      handlesToGather.push({
        type: TABLE_DRAG_HANDLE,
        gridLayoutId: currHoverPosition.gridLayoutId,
        depth: currHoverPosition.depth,
        id: currHoverPosition.id,
        layoutNodeType: currHoverPosition.layoutNodeType,
        isGridCell: currHoverPosition.isGridCell,
        parentId: (_nextHoverPosition3 = nextHoverPosition) === null || _nextHoverPosition3 === void 0 ? void 0 : _nextHoverPosition3.id
      });
    } else if (currHoverPosition.layoutNodeType === layoutNodeTypes.GRID_LAYOUT_MODULE) {
      var _nextHoverPosition4;
      handlesToGather.push({
        type: MODULE_DRAG_HANDLE,
        gridLayoutId: currHoverPosition.gridLayoutId,
        depth: currHoverPosition.depth,
        id: currHoverPosition.id,
        layoutNodeType: currHoverPosition.layoutNodeType,
        isGridCell: currHoverPosition.isGridCell,
        parentId: (_nextHoverPosition4 = nextHoverPosition) === null || _nextHoverPosition4 === void 0 ? void 0 : _nextHoverPosition4.id
      });
    }
  }
  const sectionId = hoverPositions.length > 1 ? hoverPositions[hoverPositions.length - 2].id : null;
  if (sectionId) {
    const sectionPosition = hoverPositions[hoverPositions.length - 2];
    const parentPosition = hoverPositions[hoverPositions.length - 1];
    handlesToGather.push({
      id: sectionId,
      parentId: parentPosition.id,
      gridLayoutId: sectionPosition.gridLayoutId,
      type: INSERT_NEW_SECTION_HANDLE,
      depth: hoverPositions[hoverPositions.length - 2].depth
    });
    handlesToGather.push({
      id: sectionId,
      parentId: parentPosition.id,
      gridLayoutId: sectionPosition.gridLayoutId,
      type: TOPMOST_SECTION_ROW_DRAG_HANDLE,
      depth: sectionPosition.depth,
      // @ts-expect-error fix when HoverPosition types are updated for Grids
      layoutNodeType: sectionPosition.layoutNodeType,
      isGridCell: false
    });
  }
  return handlesToGather;
}
const calculateDnDAreaDragHandlesFromHoverPositions = hoverPositions => {
  if (hoverPositions[0].type !== hoverTypes.INNER_TRIANGLE) {
    hoverPositions = hoverPositions.slice(1);
  }
  const handlesToGather = [];
  let leafModuleId;
  let firstColumnIdWithAnyRows;
  let firstRowIdWithMoreThanOneColumn;
  let currentHoverPositionIndex = 0;
  let nextHoverPosition;
  for (const hoverPosition of hoverPositions) {
    nextHoverPosition = hoverPositions[currentHoverPositionIndex + 1];
    if (!leafModuleId && hoverPosition.isModule && hoverPosition.numChildRows === 0) {
      leafModuleId = hoverPosition.id;
      const moduleDragHandle = {
        id: hoverPosition.id,
        layoutSectionId: hoverPosition.layoutSectionId,
        type: MODULE_DRAG_HANDLE,
        depth: hoverPosition.depth
      };
      // Special case early abort of drag handle computation if the module being
      // hovered over has a chance of overlaping other nodes in the tree
      if (hoverPosition.isFixedPosition || hoverPosition.isAbsolutePosition) {
        return [moduleDragHandle];
      } else {
        handlesToGather.push(moduleDragHandle);
      }
    } else if (!firstColumnIdWithAnyRows && hoverPosition.isColumn) {
      // If we haven't found any column handles yet (starting from the deepest hover position)..
      //  - Make any empty column have a empty container toolbar (that looks like the module toolbar).
      //    And also give the empty column a column toolbar.
      //  - Give the deepest, non-root column toolbar, even if it only has a single row in it
      if (hoverPosition.numChildRows === 0) {
        handlesToGather.push({
          id: hoverPosition.id,
          layoutSectionId: hoverPosition.layoutSectionId,
          type: EMPTY_CONTAINER_DRAG_HANDLE,
          depth: hoverPosition.depth
        });
      }
      if (hoverPosition.depth !== 0) {
        firstColumnIdWithAnyRows = hoverPosition.id;
        handlesToGather.push({
          id: hoverPosition.id,
          layoutSectionId: hoverPosition.layoutSectionId,
          parentId: nextHoverPosition.id,
          type: COLUMN_DRAG_HANDLE,
          depth: hoverPosition.depth
        });
      }
    } else if (!firstRowIdWithMoreThanOneColumn && hoverPosition.isRow) {
      // If we haven't found any row handles yet (starting from the deepest hover position)..
      //  - Make any empty row have a empty container toolbar (that looks like the module toolbar)
      //  - Give a toolbar to the first row with more than one column _or_ that has any styles
      //  - So we essentially are ignoring/hiding row toolbars for rows that have a single column and no styles
      if (hoverPosition.numChildColumns === 0) {
        handlesToGather.push({
          id: hoverPosition.id,
          layoutSectionId: hoverPosition.layoutSectionId,
          type: EMPTY_CONTAINER_DRAG_HANDLE,
          depth: hoverPosition.depth
        });
      }
      if (hoverPosition.numChildColumns > 1 || hoverPosition.hasLayoutStyles) {
        firstRowIdWithMoreThanOneColumn = hoverPosition.id;
        handlesToGather.push({
          id: hoverPosition.id,
          layoutSectionId: hoverPosition.layoutSectionId,
          parentId: nextHoverPosition.id,
          type: ROW_DRAG_HANDLE,
          depth: hoverPosition.depth
        });
      }
    }
    currentHoverPositionIndex += 1;
  }
  const topmostRowId = hoverPositions.length > 1 ? hoverPositions[hoverPositions.length - 2].id : null;
  if (topmostRowId) {
    if (topmostRowId === firstRowIdWithMoreThanOneColumn) {
      handlesToGather.pop();
    }
    const topmostRowPosition = hoverPositions[hoverPositions.length - 2];
    const parentPosition = hoverPositions[hoverPositions.length - 1];
    handlesToGather.push({
      id: topmostRowId,
      parentId: parentPosition.id,
      layoutSectionId: topmostRowPosition.layoutSectionId,
      type: INSERT_NEW_SECTION_HANDLE,
      depth: hoverPositions[hoverPositions.length - 2].depth
    });
    handlesToGather.push({
      id: topmostRowId,
      parentId: parentPosition.id,
      layoutSectionId: topmostRowPosition.layoutSectionId,
      type: TOPMOST_SECTION_ROW_DRAG_HANDLE,
      depth: topmostRowPosition.depth
    });
  }
  if (hoverPositions.length === 1) {
    handlesToGather.push({
      id: hoverPositions[0].id,
      parentId: null,
      isEmptyLayoutSection: true,
      layoutSectionId: hoverPositions[0].id,
      type: INSERT_NEW_SECTION_HANDLE,
      depth: 0
    });
  }
  return handlesToGather;
};
const calculateStaticDragHandlesFromHoverPosition = hoverPosition => {
  const dragHandle = {
    id: hoverPosition.id,
    uniquePositionId: hoverPosition.uniquePositionId,
    type: MODULE_DRAG_HANDLE,
    isStaticModule: hoverPosition.isStaticModule,
    isStaticSectionModule: hoverPosition.isStaticSectionModule,
    isFlexColumnModule: hoverPosition.isFlexColumnModule,
    isPostBodyModule: hoverPosition.isPostBodyModule,
    isModuleInRichText: hoverPosition.isModuleInRichText,
    isGlobalGroup: hoverPosition.isGlobalGroup,
    isGlobalPartial: hoverPosition.isGlobalPartial,
    hasDelegatedBounds: hoverPosition.hasDelegatedBounds,
    depth: hoverPosition.depth,
    isHeader: hoverPosition.isHeader,
    isFooter: hoverPosition.isFooter,
    // If a module in D&D area has fixed or absolute bounds it is treated as a "static" drag handle
    // and we still need the root ID
    layoutSectionId: hoverPosition.layoutSectionId
  };
  return [dragHandle];
};
export const calculateDragHandlesFromHoverPositions = hoverPositions => {
  if (hoverPositions.length === 0 || hoverPositions[0].type === hoverTypes.OUTSIDE_LAYOUT_SECTION) {
    return null;
  }
  const firstHoverPosition = hoverPositions[0];
  if (firstHoverPosition.isStaticModule === true || firstHoverPosition.isFlexColumnModule || firstHoverPosition.isGlobalGroup || firstHoverPosition.isGlobalPartial || firstHoverPosition.isHeader || firstHoverPosition.isFooter || firstHoverPosition.hasDelegatedBounds || firstHoverPosition.isPostBodyModule || firstHoverPosition.isModuleInRichText) {
    // Leaving this cast for now, want to clean it up but these types are a bit insane
    return calculateStaticDragHandlesFromHoverPosition(firstHoverPosition);
  } else if (firstHoverPosition.layoutSectionId) {
    return calculateDnDAreaDragHandlesFromHoverPositions(
    // If the first hover position has a layoutSectionId, then the hover
    // positions must be LayoutSectionHoverPositions
    hoverPositions);
  } else if (firstHoverPosition.layoutNodeType) {
    return calculateGridDragHandlesFromHoverPositions(hoverPositions);
  }
  return null;
};